module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._t("icon"), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._v(_vm._s(_vm.mainText))]), _vm._v(" "), _c('div', {
    staticClass: "second"
  }, [_vm._v(_vm._s(_vm.secondText))])]), _vm._v(" "), (!!_vm.rightText) ? _c('div', {
    staticClass: "right",
    style: ({
      color: _vm.rightColor
    })
  }, [_vm._v(_vm._s(_vm.rightText))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-arr"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rightArraw),
      expression: "rightArraw"
    }],
    staticClass: "icon",
    style: ({
      color: _vm.rightArrowColor
    })
  }, [_vm._v("")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1058ab5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-double-line.vue
// module id = 824
// module chunks = 34